import ArticleLayout from '@/components/feature/ArticleLayout';
import { seoArticleGuideContent } from '@/mocks/seoContent';

export default function ArticlePage() {
  return (
    <ArticleLayout
      article={seoArticleGuideContent}
      heroImage="https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20setup%20with%20laptop%20showing%20clean%20spreadsheet%20interface%2C%20cream%20ceramic%20coffee%20cup%2C%20succulent%20plant%2C%20warm%20morning%20sunlight%20through%20sheer%20curtains%2C%20beige%20and%20sand%20color%20palette%2C%20editorial%20productivity%20photography%2C%20soft%20shadows%2C%20textured%20wooden%20desk%20surface&width=1200&height=600&seq=article-hipobuy-hero-v3&orientation=landscape"
      heroImageAlt="Hipobuy Spreadsheet product finding database guide"
      heroImageTitle="Hipobuy Spreadsheet 2026 Complete Guide"
      tag="Guide"
      relatedArticles={[
        { title: "Kakobuy Spreadsheet Guide", slug: "kakobuy-spreadsheet" },
        { title: "CSSBuy Spreadsheet Guide", slug: "cssbuy-spreadsheet" },
        { title: "Superbuy Spreadsheet Guide", slug: "superbuy-spreadsheet" },
        { title: "Oopbuy Spreadsheet Guide", slug: "oopbuy-spreadsheet" },
      ]}
    />
  );
}